import React from 'react'
import { Link } from 'react-router-dom'; 
import { useState } from 'react';
import "./nepaltour.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp, faChevronDown, faChevronUp,faStar,faLocationDot,faTriangleExclamation} from "@fortawesome/free-solid-svg-icons";
const Activity = () => {
        const [isOpen, setIsOpen] = useState(false);
        const toggleSort = () => {
          setIsOpen(!isOpen);
        };
      
        const handleLongTour = () => {
            const window=0;
          if(window<window.innerHeight){
          const scrollAmount = window.innerHeight * 0.5;
          window.scrollBy({
            top: scrollAmount,
            behavior: "smooth",
          });}}
  return (
   <main>
    <section className="body">
    <div className="tourSortMobile">
     <div className="filtering">
       <div className="location">
        <p className='sortItem'>Our Location</p>
        <iframe className="google-map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3531.006345162988!2d85.29679076845517!3d27.74795029415453!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb194918041995%3A0x2290f0e48f50d549!2sUjalo%20Basthi%20Lolang%20height!5e0!3m2!1sne!2snp!4v1736396520103!5m2!1sne!2snp" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
       </div>
       <div className="popular-filter">
        <p className='sortItem'>Popular Filter</p>
        <div className="popular-sort">
            <div className="legend">
                <div id="tick"></div>
                <h5>One Day Nepal Tour</h5>
            </div>
            <div className="legend">
                <div id="tick"></div>
                <h5>Short Day Nepal Tour</h5>
            </div>
            <div className="legend">
                <div id="tick"></div>
                <h5>Medium Day Nepal Tour</h5>
            </div>
            <div className="legend"onClick={()=>handleLongTour()}>
                <div id="tick"></div>
                <h5>Long Day Nepal Tour</h5>
            </div>
        </div>
       </div>
     </div>
      {/* Sort Button */}
      <button className="sortButton" onClick={toggleSort}>
        <div className="downarrow-up">
        <FontAwesomeIcon
          icon={faArrowDown}
        />
         <FontAwesomeIcon
          icon={faArrowUp}
        />
        </div>
        <span>Sort</span>

        <FontAwesomeIcon
          icon={isOpen ? faChevronUp : faChevronDown}
          className="sortIcon"
        />
      </button>

      {/* Dropdown */}
      {isOpen && (
        <div className="sortDropdown">

          <button className="sortItem">
            One Day Tour
          </button>

          <button className="sortItem">
            Short Day Tour
          </button>

          <button className="sortItem">
            Medium Day Tour
          </button>

          <button
            className="sortItem"
            onClick={handleLongTour}
          >
            Long Day Tour
          </button>

        </div>
      )}

    </div>
     <div className="body-card">
        <h3>Nepal One Day Tour:</h3>
        <div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/Heli.webp"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
      Everest Heli Tour
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Kathmandu, Lukla</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
      $1375
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
       Breakfast (Included)
    </p>

    <Link to="/Everest-Heli-Tour"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>
<div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/katmandu.jpg"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
      Kathmandu Tour
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Kathmandu-4 Places</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
      $140
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
      Lunch (Not Included)
    </p>

    <Link to="/One-Day-Kathmandu-Tour"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>
<h3>Nepal Short Day Tour:</h3>
        <div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/real2pokhara.jpg"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
      Everest Heli Tour
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Kathmandu, Lukla</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
      $1375
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
       Breakfast (Included)
    </p>

    <Link to="/Everest-Heli-Tour"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>
<div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/tal barahi.webp"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
      Kathmandu Tour
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Kathmandu-4 Places</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
      $140
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
      Lunch (Not Included)
    </p>

    <Link to="/One-Day-Kathmandu-Tour"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>
<h3>Nepal One Day Tour:</h3>
        <div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/Heli.webp"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
      Everest Heli Tour
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Kathmandu, Lukla</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
      $1375
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
       Breakfast (Included)
    </p>

    <Link to="/Everest-Heli-Tour"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>
<div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/katmandu.jpg"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
      Kathmandu Tour
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Kathmandu-4 Places</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
      $140
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
      Lunch (Not Included)
    </p>

    <Link to="/One-Day-Kathmandu-Tour"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>
<h3>Nepal One Day Tour:</h3>
        <div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/Heli.webp"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
      Everest Heli Tour
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Kathmandu, Lukla</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
      $1375
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
       Breakfast (Included)
    </p>

    <Link to="/Everest-Heli-Tour"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>
<div className="tourCard">

{/* Image */}
<div className="tourCardImage">
  <img
    src="/img/katmandu.jpg"
    alt="Hotel"
  />
</div>

{/* Right Content */}
<div className="tourCardContent">

  {/* Info Section */}
  <div className="tourInfo">

    <h3 className="touritle">
      Kathmandu Tour
    </h3>

    <div className="tourStars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="tourLocation">
      <FontAwesomeIcon icon={faLocationDot} />
      <span>Kathmandu-4 Places</span>
    </div>

  </div>

  {/* Price Section */}
  <div className="tourPrice">

    <h3 className="price">
      $140
    </h3>

    <p className="taxText">
      All Tax Inclusive
    </p>

    <p className="hotelType">
      Lunch (Not Included)
    </p>

    <Link to="/One-Day-Kathmandu-Tour"><button className="detailsBtn">
      See Details
    </button>
</Link>
  </div>

</div>

</div>

     </div>
     
    </section>
    <div className="ser-block">
      <div className='ser-img'>
        <img src="/img/company/Capture.jpg" alt="error" />
      </div>
      <p className='ser-b-p'>This Service Is Not Available Right Now. Maintainence is ongoing !</p>
      <h3 className='ser-b'>See Other Available Services</h3>
      <div className='dfcv'><Link to="/nepal-tour" className='fhj'>Nepal Tour</Link></div>
     </div>
   </main>
  )}
export default Activity